import React, { useContext } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
// import * as moderatorActions from "../../../store/actions/Moderator/moderatoractions";
import { useState } from "react";
import styles from "src/Assets/css/home/post.module.css";
import follow from "src/Assets/images/follow.svg";
import unfollow from "src/Assets/images/unfollow.svg";
import locationIcon from "src/Assets/images/userlocationtag.svg";
// import * as childSayActions from "../../../store/actions/searchactions/childsayActionCreator";
// import * as feedactions from "../../../store/actions/feedactions/feedActionCreator";
// import PrivateTagsReducer from "../../../store/reducer/ModeratorReducer/PrivateTagsReducer";
import { styled } from "@mui/material/styles";
import { Avatar, Divider, Button } from "@mui/material";
import ChildSay from "../../Activity/Activites/ChildSay";
// import ActivityPost from "../../Activity/ActivityPost";
import sayIcon from "src/Assets/images/noofsays.svg";
import inviteIcon from "src/Assets/images/privateinvite.png";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import editIcon from "src/Assets/images/edit.svg";
import deleteIcon from "src/Assets/images/Delete.svg";
import API from "../../../network";
import InviteFollowers from "src/pages/HomePage/components/InviteFollowers";
import RestrictionMsgModal from "src/Components/RestrictionMsgModal";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { PiDotsThreeBold } from "react-icons/pi";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import PrimaryModeratorCrown from "src/Assets/images/PrimaryModeratorCrown.svg";
import SecondaryModeratorCrown from "src/Assets/images/SecondaryModeratorCrown.svg";
import SimpleDialogDemo from "../../../Modules/Reusuablecomponents/CustomizedDialogs";
import ReusuableSendaMailModal from "../../../Modules/Reusuablecomponents/ReusuableSendaMailModal";
import AvatarBadge from "src/Components/AvatarBadge";
import { ProfileHoverCard } from "src/pages/HomePage/components/ProfileHoverCard";
import EditLocation from "src/Utils/editLocation";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import SearchTagModal from "src/pages/HomePage/components/SearchedTagModal";
import dot from "src/Assets/images/dot.png";
import MapDialog from "../../../pages/HomePage/components/LocationAddress";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import replyIcon from "src/Assets/images/message new icon.png";
import closeIcon from "src/Assets/images/CloseButton.svg";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import AttachmentUploader from "src/Utils/AttachmentUploader";
import ReusuableTagActionModal from "src/Utils/ReusuableTagActionModal";
import { ignoreSpacesAndUrlsFromMsg } from "src/Utils/commonUtils";

const Container = styled("div")({
  backgroundColor: "#fff",
  margin: "20px",
  borderRadius: "20px",
  padding: "10px 10px 5px 10px",
  display: "flex",
  flexDirection: "column",
});

const Status = styled("div")({
  width: "12px",
  height: "12px",
  borderRadius: "15px",
  alignSelf: "flex-end",
  marginBottom: "6px",
  marginRight: "10px",
});

const UserName = styled("div")({
  fontSize: "14px",
  fontWeight: "700",
  color: "#333",
});

const MessageTime = styled("div")({
  fontSize: "12px",
  marginRight: "8px",
});

const NameContainer = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  marginLeft: "10px",
});

const PrivateTags = (props) => {
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [editId, seteditId] = useState(-10);
  // const [followingid, setfollowingId] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [editPrivateTag, setEditPrivateTag] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [editRestrictionMsg, setEditRestrictionMsg] = useState("");
  const [invitesShow, setInvitesShow] = React.useState(false);
  const [invite, setInvite] = useState(null);
  const [tenantId, setTenantId] = useState(null);
  const [msgId, setMsgId] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState({});
  const [openMap, setOpenMap] = useState(false);
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);
  const [startLimit, setStartLimit] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });
  const commonModalContext = useContext(CommonModalContext);

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const [data, setData] = useState([]);

  const fetchPrivateTagsData = async () => {
    try {
      setData([]);
      setShowLoader(true);
      setStartLimit(0);
      setHasMore(false);
      const response = await API.fetchPrivateTagsData(
        null,
        null,
        `tenantID=${props.tenantId}&limiter=PRI&startlimit=0`,
      );
      const rawList =
        response.data?.privateTagList ||
        response.data?.messageList?.filter(
          (each) => each.hashTagType === "private",
        ) ||
        [];
      const normalizedList = rawList.map((item) => ({
        ...item,
        id: item.id || item.messageId,
      }));
      setData(normalizedList);
      setHasMore(normalizedList.length >= 10);
      setShowLoader(false);
    } catch (e) {
      console.error(e);
      setShowLoader(false);
    }
  };

  const loadMorePrivateTags = async () => {
    if (loadingMore || !hasMore) return;
    try {
      setLoadingMore(true);
      const nextStartLimit = startLimit + 10;
      const response = await API.fetchPrivateTagsData(
        null,
        null,
        `tenantID=${props.tenantId}&limiter=PRI&startlimit=${nextStartLimit}`,
      );
      const rawList =
        response.data?.privateTagList ||
        response.data?.messageList?.filter(
          (each) => each.hashTagType === "private",
        ) ||
        [];
      const newRecords = rawList.map((item) => ({
        ...item,
        id: item.id || item.messageId,
      }));
      if (newRecords.length === 0) {
        setHasMore(false);
      } else {
        setData((prev) => [...prev, ...newRecords]);
        setStartLimit(nextStartLimit);
        if (newRecords.length < 10) {
          setHasMore(false);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingMore(false);
    }
  };

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  useEffect(() => {
    if (props.tenantId) {
      fetchPrivateTagsData();
    }
  }, [props.tenantId]);

  const onClickSendEmailOption = (selectedPost) => {
    setEmailPopupOpen(true);
    setSelectedPost(selectedPost);
  };

  var childsayid = "";
  const onSayClick = (id, e) => {
    childsayid = `childsay${id}`;
    e.preventDefault();
    if (document.getElementById(childsayid).style.display === "block") {
      document.getElementById(childsayid).style.display = "none";
    } else {
      // dispatch(childSayActions.fetchChildSayData(`?id=${id}`));
      API.fetchChildSaysData(id);
      document.getElementById(childsayid).style.display = "block";
    }
  };

  const increaseSayCount = (id) => {
    const updatedData = data.map((item) => {
      if (String(item.id) === String(id)) {
        const count = Number(item.sayCount) || 0;
        return { ...item, sayCount: count + 1 };
      } else {
        return item;
      }
    });
    setData(updatedData);
  };

  const decreaseSayCount = (id) => {
    const updatedData = data.map((item) => {
      if (String(item.id) === String(id)) {
        const count = Number(item.sayCount) || 0;
        return { ...item, sayCount: Math.max(0, count - 1) };
      } else {
        return item;
      }
    });
    setData(updatedData);
  };

  const onFollowUnFollow = (id, followstatus) => {
    // if any user who unfollows the private tag should able to see an alert
    if (followstatus === "isFollow=0") {
      setShowUnfollowAlert({
        id,
        followstatus,
      });
    } else {
      followunfollow(id, followstatus);
    }
  };

  const followunfollow = (id, followstatus) => {
    API.fetchFollowUnfollowData(id, followstatus)
      .then((res) => {
        const updatedData = data.map((each) => {
          if (each.id === id) {
            return {
              ...each,
              followStatus: each.followStatus === "Y" ? "N" : "Y",
              followCount:
                each.followStatus === "Y"
                  ? each.followCount - 1
                  : each.followCount + 1,
            };
          } else {
            return each;
          }
        });
        setData(updatedData);
      })
      .catch((e) => console.log(e));
  };

  const onLikeUnlikeSelection = (id, cache) => {
    // var likedid = `like${id}`;
    // var unlikedid = `unlike${id}`;
    // var countid = `uncount${id}`;
    // var likedcountid = `counted${id}`;

    // console.log(countid, "", likedcountid)

    if (cache === "cacheUpdate") {
      // document.getElementById(likedid).style.display = "none";
      // document.getElementById(unlikedid).style.display = "block";
      // document.getElementById(countid).style.display = "none"
      // document.getElementById(likedcountid).style.display = "block"
    }
    // likestatusparams = `?id=${id}&&cacheStatus=${cache}`;
    API.fetchVoteUpStatus(id, cache);
    // dispatch(feedactions.fetchVoteUpStatus(likestatusparams));
  };
  // <p>{data?.PrivateTagsData?.privateTagList[0]?.displayName}</p>
  //  <p>{data?.PrivateTagsData?.privateTagList[0]?.Message}</p>

  const currStatus = (status) => {
    switch (status) {
      case "A":
        return { color: "green", status: "Approved" };
      default:
        return { color: "#efba29", status: "Rejected" };
    }
  };

  const handleEdit = (tag) => {
    console.info("Editing tag with messageId:", tag?.id);
    setEditPrivateTag(tag);
    setIsEditable(true);
  };

  const updateNewSelectedLocation = (newSelectedLoc) => {
    const newData = [...data];
    const modifiedData = newData.find((x) => x.id === editPrivateTag.id);
    if (modifiedData) {
      // modifiedData.locName = newSelectedLoc;
      modifiedData.newSelectedLocation = newSelectedLoc; // Added a temporary key-value pair
    }
    setData(newData);
  };

  const removeNewSelectedLocationKey = () => {
    const newData = data.map((item) => {
      // Create a copy of the object without mutating the original
      const { newSelectedLocation, ...rest } = item; // Destructure and exclude the temporary key
      return rest; // Return the object without the temporary key
    });
    setData(newData); // Update the state with the cleaned array
  };

  const onSavePrivateTag = async (newMessage, location, attachment) => {
    try {
      const { id, locName, msgLat, msgLng } = editPrivateTag || {};
      const locationName = locName || "";
      const msgLoc = msgLat && msgLng ? `${msgLat || ""},${msgLng || ""}` : "";

      let formData = new FormData();
      if (location?.latitude && location?.longitude) {
        const lat = `${location.latitude},${location.longitude}`;
        formData.append("msgLoc", lat);
      }
      if (location?.selectedAddress) {
        formData.append("locName", location.selectedAddress);
      }

      formData.append("userLoc", "");
      formData.append("messageID", id);
      formData.append("message", newMessage);

      const resp = await API.editPrivateTagLocation(formData);
      if (attachment) {
        const attachmentFormData = new FormData();
        attachmentFormData.append("file", attachment);
        attachmentFormData.append("messageID", id);

        const response = await API.updateAttachment(attachmentFormData);
      }
      const status = resp?.data?.status || "";
      if (String(status).toLowerCase() === "edited successfully") {
        const copiedData = [...data];
        const tempUrl =
          attachment instanceof File ? URL.createObjectURL(attachment) : null;
        const updatedData = copiedData.map((each) => {
          const updatedMessage = each.id === id ? newMessage : each.Message;
          return {
            ...each,
            Message: updatedMessage,
            locName: location.selectedAddress,
            docName: attachment?.name || each.docName || "",
            docLocation: tempUrl || each.docLocation || "",
            docTagged: attachment ? 1 : each.docTagged,
          };
        });
        setData(updatedData);
      } else if (String(status).toLowerCase() === "new hash") {
        setEditRestrictionMsg("You can't create New #TAG");
      } else {
        //status: "Please retain #kalki"
        setEditRestrictionMsg(status);
      }

      //reset flag and id
      resetEditableFields();
    } catch (e) {
      console.error(e);
      alert("Something went wrong");
    }
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        // Update UI immediately without mutating state
        setData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, docName: null, docLocation: null, docTagged: 0 }
              : item,
          ),
        );
        setIsAttacmentDeleted(response?.data?.status);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    } finally {
      setActiveTooltip(null);
    }
  };
  
  const onHashTagClick = (hashTag) => {
    if (typeof hashTag === "object") {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag: hashTag.hashtag,
        tagActivityTenantId: hashTag.tenantId,
      });
    } else {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, { hashTag });
    }
  };

  const resetEditableFields = () => {
    setEditPrivateTag({});
    setIsEditable(false);
  };

  const handleDelete = async (messageId) => {
    await API.deletePrivateTag(`?messageID=${messageId}`)
      .then(() => {
        const updatedData = data.filter((each) => each.id !== messageId);
        setData(updatedData);
      })
      .catch((err) => {});
  };

  const onInviteSelection = (tenantId, id) => {
    setInvitesShow(true);
    setInvite(true);
    setTenantId(tenantId);
    setMsgId(id);
  };

  return (
    <>
      {showLoader && (
        <div className="d-flex flex-direction-row justify-content-center mt-5">
          <CircularProgress size={30} />
        </div>
      )}

      {data.length !== 0 ? (
        <div>
          {data.map((item) => (
            <Container key={item.id}>
              <div className={styles.profileMessagePopupMainContainer}>
                <div className={feedstyles.avatardetails}>
                  <div className={feedstyles.avatarContainer}>
                    <AvatarBadge
                      src={`${profileImagePath}${item.uimage}`}
                      className={styles.avatar}
                      variant="square"
                      isPrimaryModerator={item?.mainuserdata?.isPM == 1}
                      isModerator={
                        item?.mainuserdata?.isModerator == 1 &&
                        item?.mainuserdata?.isPM == 0
                      }
                    />
                    <ProfileHoverCard
                      result={{
                        ...item,
                        mainuserdata: {
                          ...item?.mainuserdata,
                          displayName:
                            item?.mainuserdata?.displayName || item?.displayName,
                          uimage: item?.mainuserdata?.uimage || item?.uimage,
                          shortBio:
                            item?.mainuserdata?.shortBio || item?.shortBio,
                          isPM: item?.mainuserdata?.isPM ?? item?.isPM,
                          isModerator:
                            item?.mainuserdata?.isModerator ?? item?.isModerator,
                        },
                      }}
                    />
                  </div>
                  <NameContainer>
                    <UserName className={feedstyles.profilename}>
                      {item.displayName}
                    </UserName>
                    <div
                      style={{ display: "flex", color: "rgba(0, 0, 0, 0.7)" }}
                    >
                      <span
                        className={feedstyles.profiletime}
                        style={{ fontSize: "12px" }}
                      >
                        {item.Message_Time}{" "}
                        {item.edited === 1 && (
                          <span> (edited {item.updated_time})</span>
                        )}
                      </span>
                      {(item.locName || item.newSelectedLocation) && (
                        <span className={styles.locationNameAndIconContainer}>
                          <img src={dot} alt="dot" />
                          <span
                            className={styles.locationNameContent}
                            onClick={() =>
                              handleClickOpen(
                                item.locName,
                                item.msgLat,
                                item.msgLng,
                              )
                            }
                          >
                            <img
                              src={locationIcon}
                              alt="location"
                              className={styles.locationIcon}
                            />
                            {item.newSelectedLocation || item.locName}
                          </span>
                        </span>
                      )}
                    </div>
                  </NameContainer>
                </div>

                <Menu viewScroll="close" reposition="auto" position="anchor"
                  menuButton={
                    <IconButton
                      style={{
                        padding: 0,
                        width: 30,
                        height: 30,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* <MdKeyboardArrowDown fontSize={25} /> */}
                      <PiDotsThreeBold
                        fontSize={25}
                        color="rgba(0, 0, 0, 0.7)"
                      />
                    </IconButton>
                  }
                  transition
                  direction="bottom"
                  arrow
                  menuStyle={{
                    backgroundColor: "white",
                    borderRadius: 20,
                  }}
                  align="end"
                >
                  {item.User_ID && userDetails && userDetails.userData && (
                    <>
                      {item.User_ID === userDetails.userData.User_ID ? (
                        <>
                          {(item.Keyword_ID === "hashTAG" ||
                            item.message_type === "X" ||
                            item.message_type === "H") && (
                            <MenuItem>
                              <ReusuableTagActionModal
                                type="download"
                                tagId={item?.id}
                                tagName={item?.Message}
                                tagData={item}
                              />
                            </MenuItem>
                          )}
                          {(item.Keyword_ID === "hashTAG" ||
                            item.message_type === "X" ||
                            item.message_type === "H") && (
                            <MenuItem>
                              <ReusuableTagActionModal
                                type="rating"
                                tagId={item?.id}
                                tagName={item?.Message}
                                tagData={item}
                              />
                            </MenuItem>
                          )}
                          <MenuItem onClick={() => handleEdit(item)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={editIcon} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="edit" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Edit tag</span>
        </div>
      </MenuItem>
                          <MenuItem onClick={() => handleDelete(item.id)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={deleteIcon} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="delete" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Delete tag</span>
        </div>
      </MenuItem>
                        </>
                      ) : (
                        <>
                          {(item.Keyword_ID === "hashTAG" ||
                            item.message_type === "X" ||
                            item.message_type === "H") && (
                            <MenuItem>
                              <ReusuableTagActionModal
                                type="download"
                                tagId={item?.id}
                                tagName={item?.Message}
                                tagData={item}
                              />
                            </MenuItem>
                          )}
                          {(item.Keyword_ID === "hashTAG" ||
                            item.message_type === "X" ||
                            item.message_type === "H") && (
                            <MenuItem>
                              <ReusuableTagActionModal
                                type="rating"
                                tagId={item?.id}
                                tagName={item?.Message}
                                tagData={item}
                              />
                            </MenuItem>
                          )}
                          <MenuItem onClick={() => handleDelete(item.id)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
          <img src={deleteIcon} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="delete" />
          <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Delete tag</span>
        </div>
      </MenuItem>
                          <MenuItem>
                            <ReusuableSendaMailModal
                              displayName={item.mainuserdata.displayName}
                              id={item.id}
                              notificationStatus={
                                item.mainuserdata.notificationStatus
                              }
                            />
                          </MenuItem>
                        </>
                      )}
                    </>
                  )}
                </Menu>
              </div>
              {isEditable && item.id === editPrivateTag?.id ? (
                <EditPrivateTag
                  onSave={onSavePrivateTag}
                  onCancel={() => setIsEditable(false)}
                  defaultMessage={item.Message}
                  latitude={item.msgLat}
                  longitude={item.msgLng}
                  locationAddress={item.locName}
                  updateNewSelectedLocation={updateNewSelectedLocation}
                  removeNewSelectedLocationKey={removeNewSelectedLocationKey}
                  docName={item?.docName}
                  onDeleteAttachment={handleDeleteAttachementDoc}
                  isAttacmentDeleted={isAttacmentDeleted}
                  setIsAttacmentDeleted={setIsAttacmentDeleted}
                  editPostId={item?.id}
                />
              ) : (
                <div
                  style={{
                    marginTop: "6px",
                    display: "inline-flex",
                    alignItems: "baseline",
                    flexWrap: "wrap",
                    gap: "5px",
                  }}
                >
                  {/* {item.Message} */}
                  <TextWithUrlsAndHashTags
                    Message={item.Message}
                    text={item.msg}
                    hashtags={item.tag}
                    urls={item.url}
                    tagActivityTenantId={item?.TenantID}
                    onHashtagClick={onHashTagClick}
                  />
                  <PostAttachmentViewer
                    docLocation={item.docLocation}
                    docTagged={item.docTagged}
                    docName={item.docName}
                    messageID={item.id}
                    className={feedstyles.myFileNameSpacingAllFeed}
                    activeTooltip={activeTooltip}
                    setActiveTooltip={setActiveTooltip}
                  />
                </div>
              )}
              {/* <div style={{ marginTop: "6px" }}>
                {item.followCount} followers. {item.hashTagType}
              </div> */}
              <div
                style={{
                  display: "flex",
                  justifyItems: "center",
                  justifyContent: "space-between",
                  fontSize: "11px",
                }}
              >
                <SimpleDialogDemo
                  followCount={item?.followCount}
                  followData={item?.follweduserprofile}
                  id={item.id}
                  // status={followData}
                  hashTagType={item?.hashTagType}
                />
                <Status
                  style={{
                    backgroundColor: currStatus(item.msg_message_status_s)
                      .color,
                  }}
                />
              </div>
              <Divider variant="fullWidth" />
              <div className={styles.privateTagButtonContainer}>
                <Button
                  className={styles.privateButton}
                  sx={{
                    ":hover": {
                      bgcolor: "#fff",
                    },
                  }}
                  onClick={() => {
                    seteditId(item.id === editId ? -10 : item.id);
                  }}
                >
                  <div className={styles.privateButtonDescriptionContainer}>
                    <img
                      src={replyIcon}
                      alt="sayIcon"
                      className={styles.privateButtonIconImage}
                      style={{ marginBottom: "-2px" }}
                    />
                    <p className={styles.privateButtonParagraph}>
                      {item?.sayCount === 0
                        ? "Reply"
                        : `${item?.sayCount} ${
                            item?.sayCount === 1 ? "Reply" : "Replies"
                          }`}
                    </p>
                  </div>
                </Button>
                <Button
                  className={styles.privateButton}
                  sx={{
                    ":hover": {
                      bgcolor: "#fff",
                    },
                  }}
                  onClick={() =>
                    onFollowUnFollow(
                      item.id,
                      item.followStatus === "Y" ? "isFollow=0" : "isFollow=1",
                    )
                  }
                >
                  <div className={styles.privateButtonDescriptionContainer}>
                    <img
                      src={item.followStatus === "Y" ? unfollow : follow}
                      alt={
                        item.followStatus === "Y"
                          ? "unfollow-icon"
                          : "follow-icon"
                      }
                      className={styles.privateButtonIconImage}
                    />
                    <p className={styles.privateButtonParagraph}>
                      {item.followStatus === "Y" ? "Unfollow" : "Follow"}
                    </p>
                  </div>
                </Button>

                <button className={styles.privateButton} onClick={() => {}}>
                  <div className={styles.privateButtonDescriptionContainer}>
                    <img
                      src={inviteIcon}
                      alt="invite-icon"
                      className={styles.privateButtonIconImage}
                      onClick={() =>
                        onInviteSelection(
                          item.TenantID || item.tenantID,
                          item.id,
                        )
                      }
                    />
                    <p
                      className={styles.privateButtonParagraph}
                      onClick={() =>
                        onInviteSelection(
                          item.TenantID || item.tenantID,
                          item.id,
                        )
                      }
                    >
                      Invite
                    </p>
                  </div>
                </button>
              </div>
              {item.id === editId && (
                <ChildSay
                  item={item}
                  id={item.id}
                  increaseSayCount={increaseSayCount}
                  decreaseSayCount={decreaseSayCount}
                  isPm={props.isPm}
                />
              )}
              {/* {item.User_ID == followingid&& (
            <ActivityPost item={{...item,id:item.User_ID}}
          )} */}
            </Container>
          ))}
          <InviteFollowers
            show={invitesShow}
            onHide={() => setInvitesShow(false)}
            invite={invite}
            tenantid={tenantId}
            msgid={msgId}
          />
          {!!editRestrictionMsg && (
            <RestrictionMsgModal
              open={!!editRestrictionMsg}
              onClose={() => setEditRestrictionMsg("")}
              message={editRestrictionMsg}
            />
          )}
          {hasMore && (
            <div className="d-flex justify-content-center my-3">
              <Button
                variant="outlined"
                onClick={loadMorePrivateTags}
                disabled={loadingMore}
                style={{
                  borderRadius: 20,
                  textTransform: "none",
                  color: "#4795de",
                  borderColor: "#4795de",
                }}
              >
                {loadingMore ? <CircularProgress size={20} /> : "Load More"}
              </Button>
            </div>
          )}
        </div>
      ) : (
        <div className="d-flex flex-direction-row justify-content-center mt-5">
          {!showLoader && <p>No Data Available</p>}
        </div>
      )}
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
      {showUnfollowAlert && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setShowUnfollowAlert(null)}
          type={"warning"}
          title={"Are you sure you want to Unfollow?"}
          acceptLabel={"Yes"}
          onAccept={() => {
            followunfollow(
              showUnfollowAlert?.id,
              showUnfollowAlert?.followstatus,
            );
            setShowUnfollowAlert(null);
          }}
        />
      )}
    </>
  );
};

export default PrivateTags;

function EditPrivateTag({
  defaultMessage,
  onSave,
  onCancel,
  latitude,
  longitude,
  locationAddress,
  updateNewSelectedLocation,
  removeNewSelectedLocationKey,
  docName,
  onDeleteAttachment,
  isAttacmentDeleted,
  setIsAttacmentDeleted,
  editPostId,
}) {
  const [message, setMessage] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [attachment, setAttachment] = useState(null);

  const [location, setLocation] = useState({
    selectedAddress: locationAddress,
    latitude: latitude,
    longitude: longitude,
  });

  useEffect(() => {
    setMessage(defaultMessage ? defaultMessage.trimEnd() : "");
  }, [defaultMessage]);

  useEffect(() => {
    let msg = message || "";
    // msg = msg.replace(/\n/g, "");
    // msg = msg.replace(/\s/g, "");
    const { msgLength } = ignoreSpacesAndUrlsFromMsg(msg);
    setCharCount(msgLength);
  }, [message]);

  const handleLocationUpdate = (address, lat, lng) => {
    setLocation({
      selectedAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleLocationDelete = () => {
    setLocation({
      selectedAddress: "",
      latitude: "",
      longitude: "",
    });
  };

  const handleCancel = () => {
    removeNewSelectedLocationKey && removeNewSelectedLocationKey();
    setErrMessage("");
    onCancel && onCancel();
  };

  const handleSave = (attachment) => {
    if (isValid()) {
      onSave && onSave(message ? message.trimEnd() : "", location, attachment);
    }
  };

  const handleInputChange = (value) => {
    setMessage(value);
    setErrMessage("");
  };

  const getWordWithHash = (sentence) => {
    const regex = /(?:^|\s)(#\w+)\b/g;

    // Find all matches in the sentence
    const matches = sentence.match(regex);

    // Return the array of matched words (or an empty array if no matches)
    return matches ? matches.map((match) => match.trim()) : [];
  };

  const isValid = () => {
    const isAttachmentUpdated = isAttacmentDeleted === "success" ? true : false;
    const cleanDefault = (defaultMessage || "").trimEnd();
    const cleanMsg = (message || "").trimEnd();
    if (
      cleanDefault === cleanMsg &&
      locationAddress === location?.selectedAddress &&
      !attachment &&
      !isAttachmentUpdated
    ) {
      setErrMessage("At least one modification required");
      return false;
    }

    const previousHashArr = getWordWithHash(defaultMessage || "");
    const previousHash =
      Array.isArray(previousHashArr) && previousHashArr.length > 0
        ? previousHashArr[0]
        : "";

    const currentHashArr = getWordWithHash(message || "");
    const currentHash =
      Array.isArray(currentHashArr) && currentHashArr.length > 0
        ? currentHashArr[0]
        : "";

    if (previousHash !== currentHash) {
      setErrMessage("You can't create a New hash tag");
      return false;
    }

    return true;
  };

  const enabled = message && charCount > 0 && charCount <= 280;

  return (
    <div>
      <div className={styles.textareaContainer}>
        <textarea
          rows="2"
          cols="48"
          value={message}
          onChange={(e) => handleInputChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          className={styles.EditPostMessage}
          style={{ marginTop: "10px" }}
          // maxLength={280}
        />
      </div>
      {errMessage && (
        <span style={{ fontSize: 11, color: "red" }}>{errMessage}</span>
      )}
      {isFocused && (
        <div className={styles.postAttachmentIconsAndActionBtnMainTopContainer}>
          <div className={styles.saveCancelButtonContainer}>
            <div className={styles.postAttachmentIconsContainer}>
              <div className={styles.postLocationAttachmentTextContainer}>
                <EditLocation
                  postLattitude={latitude}
                  postLongitude={longitude}
                  onLocationChange={handleLocationUpdate}
                  updateNewSelectedLocation={updateNewSelectedLocation}
                />
                {location.selectedAddress && (
                  <div className={styles.childfileLocationItem}>
                    <span className={styles.childfileLocationName}>
                      {location.selectedAddress}
                    </span>
                    <button
                      type="button"
                      onClick={handleLocationDelete}
                      className={styles.removeBtn}
                    >
                      <img
                        src={closeIcon}
                        alt="closeIcon"
                        className={styles.deleteIcon}
                      />
                    </button>
                  </div>
                )}
              </div>
              <AttachmentUploader
                onFileSelect={setAttachment}
                allowMultiple={false}
                docName={docName}
                onDeleteAttachment={onDeleteAttachment}
                editPostId={editPostId}
              />
            </div>
            {!location.selectedAddress && !docName && !attachment && (
              <div className={styles.saveCancelBtnContainer}>
                <button
                  onClick={() => handleSave(attachment)}
                  className={styles.editPost}
                  disabled={!enabled}
                  style={{ opacity: enabled ? 1 : 0.6 }}
                >
                  Save
                </button>
                <button
                  onClick={handleCancel}
                  className={styles.editCancelPost}
                >
                  Cancel
                </button>
              </div>
            )}
            <span>
              <label style={{ color: charCount > 280 ? "red" : "black" }}>
                {charCount}
              </label>
              <label>/280</label>
            </span>
          </div>
          {(location.selectedAddress || docName || attachment) && (
            <div
              className={styles.saveCancelBtnContainer}
              style={{ margin: "auto" }}
            >
              <button
                onClick={() => handleSave(attachment)}
                className={styles.editPost}
                disabled={!enabled}
                style={{ opacity: enabled ? 1 : 0.6 }}
              >
                Save
              </button>
              <button onClick={handleCancel} className={styles.editCancelPost}>
                Cancel
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
